import React from 'react';
import { ReactSelect } from 'components/form/field/react_select';
import { TRIGGER_TYPE_OPTIONS } from '../constants';

interface ITriggerTypeFilterProps {
  selectedTriggerTypes: string[];
  setSelectedTriggerTypes: (types: string[]) => void;
}

export const TriggerTypeFilter: React.FC<ITriggerTypeFilterProps> = props => {
  return (
    <ReactSelect
      label="Trigger"
      isMulti
      fields={TRIGGER_TYPE_OPTIONS}
      value={TRIGGER_TYPE_OPTIONS.filter(opt => props.selectedTriggerTypes.includes(opt.value))}
      handleOnChange={(selected: any) => {
        if (props.selectedTriggerTypes.includes('all')) {
          // If "All" was previously selected, clear all and add the newly selected types (except "All")
          const newSelectedTypes =
            selected?.map((s: any) => s.value).filter((v: string) => v !== 'all') || [];
          props.setSelectedTriggerTypes(newSelectedTypes.length > 0 ? newSelectedTypes : ['all']);
        } else if (selected?.some((s: any) => s.value === 'all')) {
          // If "All" is selected, set to only "All"
          props.setSelectedTriggerTypes(['all']);
        } else {
          // Otherwise, set to the selected types
          props.setSelectedTriggerTypes(selected?.map((s: any) => s.value) || []);
        }
      }}
    />
  );
};
